import React, { useState, useEffect } from "react"
import { Container, Row, Col } from "reactstrap"
import { withTranslation } from "react-i18next"
import Breadcrumbs from "components/Common/Breadcrumb"
import { useLoading } from "helpers/custom_hooks"
import PartList from "pages/Dashboard/PartList"
import { GetMyParts } from "helpers/backend_helper"
import { IsPartnerCockpitModuleEnabled } from "helpers/misc_helpers"
import { Link } from "react-router-dom"

const MyMaterialStockList = props => {
  const [parts, setParts] = useState([])
  const setLoading = useLoading()
  const [partnerCockpitEnabled, setPartnerCockpitEnabled] = useState(false)

  const loadPermissions = async _ => {
    const isEnabled = await IsPartnerCockpitModuleEnabled()
    setPartnerCockpitEnabled(isEnabled)
  }

  useEffect(() => {
    loadPermissions()
  }, [])

  useEffect(() => {
    loadParts()
  }, [])

  const loadParts = async () => {
    setLoading(true)
    const parts = await GetMyParts()
    setParts(parts)
    setLoading(false)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {partnerCockpitEnabled ? (
            <>
              <Breadcrumbs
                title={props.t("Partner Cockpit")}
                breadcrumbItem={props.t("My Material Stock")}
              />
              <PartList
                parts={parts}
                loadParts={loadParts}
                heading={props.t("My Material Stock")}
                showPartnerCockpitFilter
              />
            </>
          ) : (
            <Row>
              <Col lg="12">
                <div className="text-center mb-5">
                  <h1 className="display-2 fw-medium">
                    4<i className="bx bx-buoy bx-spin text-primary display-3" />
                    3
                  </h1>
                  <h4 className="text-uppercase">
                    Sorry, you are not allowed to view this page
                  </h4>
                  <p className="text-primary">
                    This is a premium feature. To use this feature, please
                    upgrade your license!
                  </p>
                  <div className="mt-5 text-center">
                    <Link
                      className="btn btn-primary waves-effect waves-light "
                      to="/settings?tab=2"
                    >
                      Upgrade Account
                    </Link>
                    <br />
                    <Link className=" d-block mt-4" to="/dashboard">
                      <i className="bx bx-left-arrow-alt" />
                      Back to Dashboard
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(MyMaterialStockList)
